import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getMachineBrigades(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_BRIGADE,
		ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADES,
		options
	)
}

function _createMachineBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_BRIGADE,
		ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].CREATE_BRIGADE,
		options
	)
}

function _getMachineBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_BRIGADE,
		ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADE,
		options
	)
}

function _patchMachineBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_BRIGADE,
		ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PATCH_BRIGADE,
		options
	)
}

function _putMachineBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_BRIGADE,
		ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PUT_BRIGADE,
		options
	)
}

function _deleteMachineBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_BRIGADE,
		ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].DELETE_BRIGADE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADES]: _getMachineBrigades,

	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].CREATE_BRIGADE]: _createMachineBrigade,
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADE]: _getMachineBrigade,
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PATCH_BRIGADE]: _patchMachineBrigade,
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PUT_BRIGADE]: _putMachineBrigade,
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].DELETE_BRIGADE]: _deleteMachineBrigade,
}